import { motion } from 'framer-motion';
import './GuaraSpeaker.css';

export default function GuaraSpeaker({ isVisible = false }) {
  if (!isVisible) return null;

  return (
    <motion.div
      className="guara-speaker"
      initial={{ opacity: 0, x: -100, scale: 0.8 }}
      animate={{
        opacity: 1,
        x: 0,
        scale: 1,
        transition: {
          duration: 0.6,
          ease: "easeOut",
          x: {
            type: "spring",
            stiffness: 200,
            damping: 20
          },
          scale: {
            type: "spring",
            stiffness: 300,
            damping: 15
          }
        }
      }}
      exit={{
        opacity: 0,
        x: -100,
        scale: 0.8,
        transition: { duration: 0.4, ease: "easeIn" }
      }}
    >
      <img
        src="/images/guara-1.png"
        alt="Guará"
        className="guara-image"
      />
    </motion.div>
  );
}
